import { InputMask } from 'imask'

export const PhoneNumberMask = {
  mask: null,
  mounted() {
    this.mask = new InputMask(this.el, { mask: '+{1} (000) 000-0000' })
    // iMask does not reformat a pre-existing value on init — it only formats
    // future user input events. Set mask.value explicitly so a server-supplied
    // value (e.g. "+1 (212) 555-1234") is displayed correctly from the start.
    if (this.el.value) {
      this.mask.value = this.el.value
    }
  },
  destroyed() {
    this.mask.destroy()
  },
}
